import React from "react";
import MDBox from "@cloudpremise/portal_core/src/themes/mui/components/MDBox";
import DashboardLayout from "@cloudpremise/portal_core/src/themes/mui/examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "@cloudpremise/portal_core/src/themes/mui/examples/Navbars/DashboardNavbar";
import Card from "@mui/material/Card";
import MDTypography from "@cloudpremise/portal_core/src/themes/mui/components/MDTypography";
import SimpleInfoCard from "@cloudpremise/portal_core/src/themes/mui/examples/Cards/InfoCards/SimpleInfoCard";
import DefaultInfoCard from "@cloudpremise/portal_core/src/themes/mui/examples/Cards/InfoCards/DefaultInfoCard";
import CenteredBlogCard from "@cloudpremise/portal_core/src/themes/mui/examples/Cards/BlogCards/CenteredBlogCard";
import { useMaterialUIController } from "@cloudpremise/portal_core/src/themes/mui/context";
import Footer from "@cloudpremise/portal_core/src/themes/mui/examples/Footer";


// @mui material components
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";


const Home = (props) => {
    const [ controller ] = useMaterialUIController();
    const { config, user } = controller;
    return (
        <DashboardLayout>
            <DashboardNavbar />
            <MDBox my={config.hideLayout ? 0 : 3}>
                <Grid container justifyContent="center" alignItems="center">
                    <Grid item xs={12} sm={12} md={12} lg={12} position="relative">
                        <MDTypography variant="h2" mb={2}>
                            Iris Enterprise Portal
                        </MDTypography>
                        <MDTypography variant="body2" mb={3}>
                            Iris Enterprise Portal is the <strong>foundational frontend experience</strong> for Olympus-Grid, delivering a <strong>secure, scalable, and customizable React-based portal</strong> that integrates seamlessly with enterprise applications. Whether deployed natively on <strong>Salesforce</strong>, hosted in a <strong>multi-cloud environment</strong>, or embedded within an ISV product, Iris Portal enables organizations to build modern, high-performance digital experiences <strong>without the complexity of traditional frontend development.</strong>
                        </MDTypography>
                        <MDTypography variant="h4">
                            Key Features
                        </MDTypography>
                        <ul>
                            <li>
                                Mobile-First, Pixel Perfect User Experiences
                                <ul>
                                    <li>From Imagination to Reality, faster than you would believe</li>
                                </ul>
                            </li>
                        </ul>
                    </Grid>
                </Grid>
            </MDBox>
        </DashboardLayout>
    )
}

export default Home;